import { vdaScore, vdaScoreCurated, vdaScoreLiterature, vdaScoreBiobank } from '../../AboutHelpers.tsx';

function AboutMetricsVdaScore(): JSX.Element {
  return (
    <div id="vdaScore">
      <h3>VDA Score</h3>
      <p>
        The DISGENET Score (S<sub style={{ fontSize: 'smaller', marginLeft: 2 }}>VDA</sub>) for VDAs is
        computed according to:
      </p>
      <span>{vdaScore()}</span>
      <br></br>
      <span>{vdaScoreCurated()}</span>
      <br></br>
      <span>{vdaScoreBiobank()}</span>
      <br></br>
      <span>{vdaScoreLiterature()}</span>
    </div>
  );
}

export default AboutMetricsVdaScore;